// @ts-strict-ignore

import {Component, PanelLifecycleContext} from 'panel';

import {Subscribable} from 'common/types/context/subscribable';
import {ReportName} from 'common/report/constants';
import {getReportName} from 'common/report/util';

export class ReportInfo implements PanelLifecycleContext, Subscribable {
  private connectedComponents: Set<Component<any>> = new Set();
  private subscriptions = [];

  // when on fastedit report, getting report name from url will report `dashboards` as the report name.
  // this allows individual reports to update report name to be fastedit report. this is useful for tracking
  reportNameOverride: ReportName = null;

  getReportName(): ReportName {
    return this.reportNameOverride ?? getReportName();
  }

  setReportNameOverride(reportNameOverride: ReportName) {
    this.reportNameOverride = reportNameOverride;
    this.updateComponents();
  }

  removeReportNameOverride() {
    this.setReportNameOverride(null);
  }

  subscribe(callback: () => void): this {
    this.subscriptions.push(callback);
    return this;
  }

  unsubscribe(callback: () => void): this {
    this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
    return this;
  }

  bindToComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.add(component);
  }

  unbindFromComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.delete(component);
  }

  updateComponents() {
    for (const component of this.connectedComponents) {
      component.update();
    }
    for (const subscription of this.subscriptions) {
      subscription();
    }
  }
}
